<template>
    <!--
           作者：peng
           时间：2020-08-19
           描述：插件中心-客户信息-自定义文字
       -->
    <div class="product-add pb50" v-loading="loading">
        <div>

            <div class="common-form">我的客户列表页面</div>
            <div class="common-seach-wrap">
                <el-form size="small" :inline="true" :model="form" class="demo-form-inline">
                    <el-form-item style="display: block" label="页面标题">
                        <el-input v-model="form.my_page_title" placeholder="请输入页面标题"></el-input>
                    </el-form-item>
                    <el-form-item style="display: block" label="客户总人数">
                        <el-input v-model="form.my_customer_count" placeholder=""></el-input>
                    </el-form-item>
                </el-form>
            </div>

            <div class="common-form">公共客户列表页面</div>
            <div class="common-seach-wrap">
                <el-form size="small" :inline="true" :model="form" class="demo-form-inline">
                    <el-form-item style="display: block" label="页面标题">
                        <el-input v-model="form.public_page_title" placeholder="请输入页面标题"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="common-form">公共客户详情页面</div>
            <div class="common-seach-wrap">
                <el-form size="small" :inline="true" :model="form" class="demo-form-inline">
                    <el-form-item style="display: block" label="我要绑定按钮">
                        <el-input v-model="form.bind_button" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item style="display: block" label="确认绑定提示">
                        <el-input v-model="form.true_bind_msg" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item style="display: block" label="取消绑定提示">
                        <el-input v-model="form.false_bind_msg" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item style="display: block" label="已经绑定按钮">
                        <el-input v-model="form.binding_button" placeholder=""></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="gotoTrue()">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomerApi from '@/api/customer.js'
    export default {
        data() {
            return {
                /*是否加载完成*/
                loading: false,
                form:{
                    my_page_title:'我的客户',
                    my_customer_count:'',
                    public_page_title:'公共客户',
                    bind_button:'',
                    binding_button:'',
                    true_bind_msg:'',
                    false_bind_msg:''
                }
            };
        },
        created() {
            this.getOpen()
        },
        methods: {
            getOpen(){
                let self = this
                CustomerApi.get_open('',true)
                    .then(data => {
                        if (data.data.list != null){
                            self.form = data.data.list;
                        }
                    })
                    .catch(error => {

                    });
            },
            gotoTrue(){
                let self = this
                let Params = self.form
                CustomerApi.put_open(Params,true)
                    .then(data => {
                        this.$message({
                            type: 'success',
                            message: "保存成功"
                        });
                        self.getOpen()
                    })
                    .catch(error => {
                        this.$message({
                            type: 'info',
                            message: '保存失败'
                        });
                    });
                console.log(self.form)
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/plus/customer/open/open.vue